<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Informativa Privacy</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <h1>Termini e condizioni per l'utilizzo delle App Maurelli</h1>
  <div class="information">
    <p>Utilizzando le app Maurelli accetti le condizioni di utilizzo e la Privacy Policy.</p>
    <p>
      <a [href]="privacyPolicyUrl" target="_blank">Leggi Privacy Policy</a>
    </p>
  </div>
  <div class="checkbox-wrapper ion-padding-vertical">
    <ion-checkbox labelPlacement="end" [value]="privacyPolicyAccepted" (ionChange)="setPolicyAccepted($event)">Ho letto e acconsento</ion-checkbox>
  </div>
  <div class="footer">
    <!-- <ion-button (click)="confirm()" [fill]="true">Chiudi</ion-button> -->
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar mauFooterSingleButton>
    <ion-button [disabled]="!privacyPolicyAccepted" color="primary" expand="block" (click)="confirm()">Chiudi </ion-button>
  </ion-toolbar>
</ion-footer>
